import React, { useState } from "react";
import axios from "axios";
import "./SendSignatureLinks.scss";
import { Modal } from "react-bootstrap";
import img from "../../../assets/images/send-email.png";
import { BASE_URL } from "config/config";
import { useTranslation } from "react-i18next";
export default function SendSignatureLinks({ signatureId, savePosition }) {
  const [loading, setLoading] = useState(false);
  const [recipients, setRecipients] = useState([]);
  const [message, setMessage] = useState("");
  const { t } = useTranslation();
  const [showRefusalModal, setShowRefusalModal] = useState(false);
  console.log(signatureId);
  const handleSendLinks = async () => {
    setLoading(true);
    setMessage("");
    try {
      const res = await axios.post(
        `${BASE_URL}signatures/${signatureId}/send-links`
      );
      console.log(res);
      setRecipients(res?.data?.data?.recipients);
      setMessage(t("signature.emailEnvoyee"));
      setShowRefusalModal(true);
    } catch (error) {
      console.error(error);
      setMessage(t("signature.emailErreur"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="send mt-3">
      <button
        onClick={handleSendLinks}
        disabled={loading || !savePosition}
        className="action-button secondary"
        style={{
          padding: "10px 20px",
          fontSize: 16,
        }}>
        {loading ? t("signature.enCours") : t("signature.envoyerDes")}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            d="M10 14.5L21 3.5M10 14.5L13.5 21.5C13.5439 21.5957 13.6143 21.6769 13.703 21.7338C13.7916 21.7906 13.8947 21.8209 14 21.8209C14.1053 21.8209 14.2084 21.7906 14.2971 21.7338C14.3857 21.6769 14.4561 21.5957 14.5 21.5L21 3.5M10 14.5L3 11C2.90426 10.9561 2.82313 10.8857 2.76625 10.7971C2.70937 10.7084 2.67913 10.6053 2.67913 10.5C2.67913 10.3947 2.70937 10.2916 2.76625 10.2029C2.82313 10.1143 2.90426 10.0439 3 10L21 3.5"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      {message && <p style={{ marginTop: 10 }}>{message}</p>}
      {showRefusalModal && (
        <Modal
          show={showRefusalModal}
          onHide={() => setShowRefusalModal(false)}
          centered
          className="modal-refus"
          size="sm"
          style={{
            borderRadius: "15px !important",
          }}
        >
          <img className="p-3" src={img} />
          <p className="succes-text">{t("signature.emailSucces")}</p>
        </Modal>
      )}

      {/*  {recipients.length > 0 && (
        <div style={{ marginTop: 20 }}>
          <h4>Destinataires :</h4>
          <ul>
            {recipients.map((r) => (
              <li key={r.email}>
                {r.name} - {r.email} - Lien :{" "}
                <a
                  href={`https://depense-sass.msit-demo.fr/sign/${r.token}`}
                  target="_blank"
                  rel="noreferrer">
                  Ouvrir
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}*/}
    </div>
  );
}
